import HttpReference from '../platform/HttpReference';

export default class VehicleMakes extends HttpReference {
  get() {
    // TODO
  }
}
